import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

import { LoggerService } from '../../shared/logger.service';
import { RestService } from './rest.service.interface';
import { RestServiceImpl } from './rest.service.impl';
import {AngularMaterial2Module} from "../../app.module.material";
import {FormsModule} from "@angular/forms";

const PATH_FILE = 'app/protected/immerdrin/oase.delete.component.ts';

@Component({
    selector: 'oase-delete.dialog',
    templateUrl: './oase.delete.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule ]

})
export class OaseDeleteDialogComponent {
  OBJ_LNG_NAME = null; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
  BACKEND_PATH_PREFIX = null;
  UEBERSETZUNG_FELDNAME = null;
  aktuell = null;

  constructor(
    public dialogRef: MatDialogRef<OaseDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dataService: RestService,
	@Inject(L10N_LOCALE) public locale: L10nLocale,
	@Inject(L10N_CONFIG) private config: L10nConfig,
	public translation: L10nTranslationService,
	private _logger: LoggerService) {

    this.OBJ_LNG_NAME = data.OBJ_LNG_NAME;
    this.BACKEND_PATH_PREFIX = data.BACKEND_PATH_PREFIX;
    this.UEBERSETZUNG_FELDNAME = data.UEBERSETZUNG_FELDNAME;
    this.aktuell = data.aktuell;

    this.dataService.init();
  }

  close(): void {
    this.dialogRef.close(false);
  }

  loeschen(): void {
    this._logger.log(PATH_FILE + ' - loeschen this.dataService.getApiUrl()', this.dataService.getApiUrl());

    // shekvl:
    // this is changed as compared to original version
    // as apiUrlPrefix is better derived from BACKEND_PATH_PREFIX and not from OBJ_LNG_NAME
    // and it is more consistent to pass everything inside "data" structure

    this.dataService.apiUrlPrefix = this.BACKEND_PATH_PREFIX;
    this.dataService.loeschen(this.aktuell.id).subscribe(data => {this.dialogRef.close(true)});
  }
}
